import { render, staticRenderFns } from "./indexManage.vue?vue&type=template&id=a7285cf6&scoped=true"
import script from "./indexManage.vue?vue&type=script&lang=js"
export * from "./indexManage.vue?vue&type=script&lang=js"
import style0 from "./indexManage.vue?vue&type=style&index=0&id=a7285cf6&lang=sass"
import style1 from "./indexManage.vue?vue&type=style&index=1&id=a7285cf6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7285cf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7285cf6')) {
      api.createRecord('a7285cf6', component.options)
    } else {
      api.reload('a7285cf6', component.options)
    }
    module.hot.accept("./indexManage.vue?vue&type=template&id=a7285cf6&scoped=true", function () {
      api.rerender('a7285cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main/indexManage.vue"
export default component.exports